<template>
  <div id="app">
    <router-view v-if="isRouterAlive" />
    <custom-footer v-if="$route.meta.hasFooter"></custom-footer>
    <global-loading></global-loading>
  </div>
</template>

<script>
import GlobalLoading from './components/GlobalLoading.vue'
// import store from './storage/index'
export default {
  data() {
    return {
      isRouterAlive: true
    }
  },
  provide() {
    return {
      reload: this.reload
    }
  },
  components: {
    'custom-footer': () => import('./components/Footer'),
    GlobalLoading
  },
  methods: {
    reload() {
      this.isRouterAlive = false
      this.$nextTick(() => {
        this.isRouterAlive = true
      })
    }
  }
}
</script>

<style lang="stylus">
@import './assets/css/base.styl';
#app {
  font-family: PingFang SC,-apple-system,BlinkMacSystemFont,Helvetica Neue,Helvetica,Segoe UI,Arial,Roboto,miui,Hiragino Sans GB,Microsoft Yahei,sans-serif
}
</style>
